import { Action } from '@ngrx/store';
import { CompanySearchFilter } from '../../models/companySearchFilter';

export enum ECompanyListActions {
  SetSearchFilter = '[Company List] SET SEARCH FILTER',
  SetPagination = '[Company List] SET PAGINATION',
  SetSort = '[Company List] SET SORT',
  ClearFilters = '[Company List] CLEAR FILTERS'
}

export class SetCompanySearchFilter implements Action {
  public readonly type = ECompanyListActions.SetSearchFilter;
  constructor(public payload: CompanySearchFilter) {}
}

export class SetCompanyPagination implements Action {
  public readonly type = ECompanyListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetCompanySort implements Action {
  public readonly type = ECompanyListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearCompanyFilters implements Action {
  public readonly type = ECompanyListActions.ClearFilters;
}

export type CompanyListActions =
  | SetCompanySearchFilter
  | SetCompanyPagination
  | SetCompanySort
  | ClearCompanyFilters;
